import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import SectionGridAuthorBox from "components/SectionGridAuthorBox/SectionGridAuthorBox";
import SectionHeroArchivePage from "components/SectionHeroArchivePage/SectionHeroArchivePage";
import React, { FC, useEffect, useRef, useState } from "react";
import SectionGridFilterCard from "./SectionGridFilterCard";
import { Helmet } from "react-helmet";
import useAuth from "components/Authprovider/Auth";
import toast from "react-hot-toast";
import { HotelType } from "data/types";
import scrollToX from "utils/scrollToX";
import { fetchData } from "data/api/fetch";

export interface ListingStayPageProps {
  className?: string;
}

const ListingStayPage: FC<ListingStayPageProps> = ({ className = "" }) => {

  const {token,search} = useAuth()
  
    const  [hotelsData,setHotelsData] = useState<HotelType[]>()

    const [data,setData] = useState()
    const firstRender = useRef(true);

    const headers = {
      "content-type": "application/json",
      "Accept": "application/json",
      "Authorization": `Bearer ${token}`,
    };
  

    useEffect(() =>{
      const getHotels = fetchData(`https://phplaravel-930928-3230982.cloudwaysapps.com/api/hotel`,{},headers)
  
      getHotels.then((data: any) => {
        // Use setData to update the state with the data
        setHotelsData(data.data)
      });
       
    },[])
      useEffect(() =>{
    if (firstRender.current) {
      firstRender.current = false;
    } else {

        const getHotels = fetchData(`https://phplaravel-930928-3230982.cloudwaysapps.com/api/search-hotel?q=${search?.location}`,{},headers)

        toast.promise(getHotels, {
          loading: "Loading data...",
          success: (data: any) => `${data.msg}`,
          error: (error) => `No search results found`,
        });
        getHotels.then((data: any) => {
          // Use setData to update the state with the data
          setHotelsData(data.data)
          scrollToX('nc-SectionGridFeaturePlaces')
        });
      }
  },[search?.location])
   

   

   
  return (
    <div
      className={`nc-ListingStayPage relative overflow-hidden ${className}`}
      data-nc-id="ListingStayPage"
    >
      <Helmet>
        <title>Hotels to book on Nilebooking</title>
      </Helmet>
      <BgGlassmorphism />

      <div className="container relative overflow-hidden">
        {/* SECTION HERO */}
        <SectionHeroArchivePage
          countListing={hotelsData?.length}
          className="pt-10 pb-24 lg:pb-28 lg:pt-16 "
        />

        {/* SECTION */}
        <SectionGridFilterCard className="pb-24 lg:pb-28" data={hotelsData} />

        {/* SECTION 1 */}
        {/*<div className="relative py-16">
          <BackgroundSection />
          <SectionSliderNewCategories
            heading="Explore by types of stays"
            subHeading="Explore houses based on 10 types of stays"
            categoryCardType="card5"
            itemPerRow={5}
            sliderStyle="style2"
            uniqueClassName="ListingStayMapPage"
          />
        </div>
        */}

        {/* SECTION */}
        {/*<SectionSubscribe2 className="py-24 lg:py-28" />*/}

        {/* SECTION */}
        <div className="relative py-16 mb-24 lg:mb-28">
          <BackgroundSection className="bg-primary-50 dark:bg-black dark:bg-opacity-20" />
          <SectionGridAuthorBox />
        </div>
      </div>
    </div>
  );
};

export default ListingStayPage;

